<template>
  <div class="field">
    <label v-if="label" :for="id" class="block text-900 font-medium mb-2">
      {{ label }}
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <MultiSelect
      v-model="selectedOptions"
      :options="options"
      :option-label="optionLabel"
      :option-value="optionValue"
      :placeholder="placeholder"
      :filter="filter"
      :disabled="disabled"
      :required="required"
      :class="{ 'p-invalid': errorMessage }"
      :show-clear="showClear"
      :loading="loading"
      :max-selected-labels="maxSelectedLabels"
      display="chip"
      class="w-full"
      @change="onChange"
      @filter="onFilter"
      :id="id"
    />
    <small v-if="errorMessage" class="p-error">{{ errorMessage }}</small>
    <small v-if="hint" class="p-d-block p-mt-1 p-text-secondary">{{ hint }}</small>
  </div>
</template>

<script>
import MultiSelect from 'primevue/multiselect';

export default {
  name: 'InputMultiSelect',
  components: {
    MultiSelect
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    optionLabel: {
      type: String,
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: () => `multiselect-${Math.random().toString(36).substr(2, 9)}`
    },
    placeholder: {
      type: String,
      default: ''
    },
    filter: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    maxSelectedLabels: {
      type: Number,
      default: 3
    },
    showClear: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    emptyMessage: {
      type: String,
      default: 'No results found'
    },
    errorMessage: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change', 'filter'],
  computed: {
    selectedOptions: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  methods: {
    getOptionLabel(option) {
      if (!option) return '';
      if (typeof option === 'object') {
        return option[this.optionLabel] || '';
      }
      const selected = this.options.find(opt => {
        const val = typeof opt === 'object' ? opt[this.optionValue] : opt;
        return val === option;
      });
      return selected ? (typeof selected === 'object' ? selected[this.optionLabel] : selected) : option;
    },
    onChange(event) {
      this.$emit('change', event);
    },
    onFilter(event) {
      this.$emit('filter', event);
    }
  }
};
</script>

<style scoped>
.field {
  margin-bottom: 1rem;
}

:deep(.p-multiselect) {
  width: 100%;
}

:deep(.p-multiselect-label) {
  padding: 0.5rem 0.75rem;
}

:deep(.p-multiselect-token) {
  background: var(--primary-color);
  color: var(--primary-color-text);
  border-radius: 0.375rem;
  padding: 0.25rem 0.5rem;
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
}
</style>